import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebSiteComponent } from './web-site-component/web-site.component';
import { BuyerPassCodeComponent } from './buyer-pass-code/buyer-pass-code.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { HappyornotComponent } from './happyornot/happyornot.component';
import { EnquiryComponent } from './enquiry/enquiry.component';
import { EcommOrderHandleComponent } from './ecomm-order-handle/ecomm-order-handle.component';

const routes: Routes = [
  {
    path: ':businessslug',
    component:
      window.location.hostname === 'feedback.instaciti.com' ||
      window.location.hostname === 'feedback.bigdot.ai' //feedback.instaciti.com
        ? FeedbackComponent
        : window.location.hostname === 'hono.instaciti.com' ||
          window.location.hostname === 'hono.bigdot.ai' //hono.instaciti.com
        ? HappyornotComponent
        : window.location.hostname === 'enquiry.instaciti.com' ||
          window.location.hostname === 'enquiry.bigdot.ai' //enquiry.instaciti.com
        ? EnquiryComponent
        : WebSiteComponent,
  },
  { path: 'otp/passcode', component: BuyerPassCodeComponent },
  {
    path: ':businessslug/:section',
    component:
      window.location.hostname === 'orderfeedback.instaciti.com' ||
      window.location.hostname === 'feedback.bigdot.ai' //orderfeedback.instaciti.com
        ? EcommOrderHandleComponent
        : HappyornotComponent,
  },
  // //
  {
    path: ':businessslug/:section/:stationId',
    component: HappyornotComponent,
  },
  { path: ':businessslug/payment/:status', component: WebSiteComponent },
  { path: ':businessslug/payment/:status', component: WebSiteComponent },

  //{ path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
